export const getIsInForeground = state => state.clientData.isInForeground;